import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subject, filter, takeUntil } from 'rxjs';

import { TranslationService } from '@mirage-projects/cw-commons';

import { UploadWizardService } from '../../../services/upload-wizard-service/upload-wizard.service';
import { PointSelectorService } from './point-selector.service';

/**
 * Point selector optional step
 * This component is used as an optional step to adjust the center postion of the imported element
 */
@Component({
    selector: 'cw-point-selector',
    templateUrl: 'point-selector.component.html',
    styleUrls: ['./point-selector.component.scss'],
    standalone: false,
})
export class PointSelectorComponent implements OnInit, OnDestroy {
    /** Text that will be shown as a definition of the wizard in all the steps */
    @Input() subtitle = '';

    pointFromPivot!: Float64Array;
    onDestroy$: Subject<void> = new Subject();

    constructor(
        public service: PointSelectorService,
        private uploadWizardService: UploadWizardService,
        private translationService: TranslationService
    ) {}

    ngOnInit(): void {
        this.pointFromPivot = this.uploadWizardService.wizardParams.worklowTaskDefinition.data.pivotPoint;
        this.listenToStepChanged();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    /**
     * Updates the form data based on the edit center checkbox state
     */
    onChangeCenterEdition(): void {
        const form = this.service.pointSelectorForm;
        if (form.get('editCenter')?.value) {
            form.patchValue({ x: this.pointFromPivot[0], y: this.pointFromPivot[1], z: this.pointFromPivot[2] });
        } else {
            form.patchValue({ x: 0, y: 0, z: 0 });
        }
    }

    /**
     * Checks if the user is moving to the next step, so the validations and summary can be done
     */
    listenToStepChanged(): void {
        this.uploadWizardService.stepChanged
            .pipe(
                takeUntil(this.onDestroy$),
                filter((wizardComponent) => {
                    const step = this.translationService.translate('WIZARD.TAB_POINT_SELECTOR');
                    return this.uploadWizardService.comparePreviousStep(wizardComponent, step);
                })
            )
            .subscribe((wizardComponent) => {
                this.updateSummary(wizardComponent.selectedIndex);
            });
    }

    private updateSummary(summaryPosition: number): void {
        const fields = [];

        fields.push({
            key: 'SCANPROC.POINT_SELECTOR_LABEL_X',
            value: this.service.pointSelectorForm.get('x')?.value,
        });
        fields.push({
            key: 'SCANPROC.POINT_SELECTOR_LABEL_Y',
            value: this.service.pointSelectorForm.get('y')?.value,
        });
        fields.push({
            key: 'SCANPROC.POINT_SELECTOR_LABEL_Z',
            value: this.service.pointSelectorForm.get('z')?.value,
        });

        this.uploadWizardService.summary[summaryPosition] = {
            title: 'SCANPROC.POINT_SELECTOR_TITLE',
            notice: 'SCANPROC.POINT_SELECTOR_NOTICE',
            fields,
        };
    }
}
